import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/purchase-requisition-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: [{
    Header: () => <HeaderLabel>เลขที่</HeaderLabel>,
    accessor: 'refId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>เลขที่ใบแจ้งซ่อม</HeaderLabel>,
    accessor: 'RepairJob.refId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ชื่อผู้ขอเบิก</HeaderLabel>,
    accessor: 'RequestBy.firstname',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>นามสกุลผู้ขอเบิก</HeaderLabel>,
    accessor: 'RequestBy.lastname',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>วันที่ครบกำหนด</HeaderLabel>,
    accessor: 'deadlineDate',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={STATUSCOLORSELECTOR(props.value)} bold>{STATUSTEXTSELECTOR(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
    key='filter'
    data={STATUS}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
